import { render, staticRenderFns } from "./typings.page.vue?vue&type=template&id=fe94250c&scoped=true"
import script from "./typings.page.vue?vue&type=script&lang=js"
export * from "./typings.page.vue?vue&type=script&lang=js"
import style0 from "./typings.page.vue?vue&type=style&index=0&id=fe94250c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe94250c",
  null
  
)

export default component.exports